/*
 *
 * UiControl constants
 *
 */

export const UI_TOGGLE = 'app/UiControl/UI_TOGGLE';
export const UI_SET = 'app/UiControl/UI_SET';
